/* eslint-disable react/no-duplicate-key */
import React, { Fragment, useMemo } from "react";

import {
	ActionMenuButton,
	DropdownMenu,
	DropdownMenuCheckboxItem,
	DropdownMenuContent,
	DropdownMenuSeparator,
	DropdownMenuTrigger
} from "../../../components";
import { useLocale } from "../../../locales";

function FontFamilyButton(props) {
	const { t, lang } = useLocale();

	const active = useMemo(() => {
		const find = props?.items?.find(k => k.isActive());

		if (find && !find.default) {
			return {
				...find
			};
		}
		const item = {
			title: props.tooltip,
			font: t("editor.fontFamily.default.tooltip"),
			isActive: () => false,
			disabled: false,
			action: () => props.editor.chain().focus().unsetFontFamily().run()
		};
		return item;
	}, [t, lang, props]);

	return (
		<DropdownMenu>
			<DropdownMenuTrigger disabled={props?.disabled} asChild>
				<ActionMenuButton
					title={
						active?.font?.length > 7 ? `${active?.font?.slice(0, 6)}...` : active?.font
					}
					tooltip={props?.tooltip}
					disabled={props?.disabled}
					icon="MenuDown"
				/>
			</DropdownMenuTrigger>
			<DropdownMenuContent className="richtext-w-full">
				{props?.items?.map((item, index) => {
					const style =
						item.font === t("editor.fontFamily.default.tooltip")
							? {}
							: { fontFamily: item.font };

					return (
						<Fragment key={`font-family-${index}`}>
							<DropdownMenuCheckboxItem
								checked={active?.font === item.font}
								onClick={item.action}
							>
								<div className="richtext-h-full richtext-ml-1" style={style}>
									{item.font}
								</div>
							</DropdownMenuCheckboxItem>
							{item.font === t("editor.fontFamily.default.tooltip") && (
								<DropdownMenuSeparator />
							)}
						</Fragment>
					);
				})}
			</DropdownMenuContent>
		</DropdownMenu>
	);
}

export default FontFamilyButton;
